import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  TableTitleBarChart,
  renderLegendsForTable,
  Error,
} from "components/Utils/Utils.js";

const metric = (cell, row, rowIndex, params) => {
  const props = { ...cell, ...params };
  return <MetricTable {...props} />;
};

class WorldCupPlatformBreakouts extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  titleWithChart = (cell, row, dataField) => {
    return (
      <TableTitleBarChart
        title={cell}
        row={row}
        bar_chart_data={row[dataField]}
      />
    );
  };

  renderTable = (data, columns, labels) => {
    const { title, url } = this.props;

    const displayTitleWithChart = url.includes(
      "telemundo/world-cup-platform-breakouts?t=world-cup-2022&dimension=device_platform"
    );

    const table_columns = [
      {
        dataField: "platform",
        text: "Platform",
        style: {
          minWidth: displayTitleWithChart ? "500px" : "90px",
          width: displayTitleWithChart ? "500px" : "90px",
          textAlign: "left",
        },
        headerAlign: "left",
        formatter: (cell, row) =>
          displayTitleWithChart
            ? this.titleWithChart(cell, row, "chart")
            : cell,
        sort: true,
      },

      {
        dataField: "min_watched",
        text: "Min Watched",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "minutes_unique",
        text: "Minutes/Unique",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "livestreams",
        text: "Livestreams (Views Starts)",
        style: { width: "140px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "minutes_stream",
        text: "Minutes/Stream",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => selectFormat("number", cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "livestream_min_share",
        text: "Livestream Min Share",
        style: { width: "120px", minWidth: "120px" },
        formatter: metric,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "livestreams_share",
        text: "Livestream Share",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "live_uniques_share",
        text: "Live Uniques Share",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "visits",
        text: "Visits",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "visitors",
        text: "Visitors",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "page_views",
        text: "Page Views",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "livestream_minutes",
        text: "Livestream Minutes",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "livestream_uniques",
        text: "Livestream Uniques",
        style: { width: "130px", minWidth: "130px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "live_stream_minutes",
        text: "Livestream Minutes",
        style: { width: "190px", minWidth: "190px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "avg_view_time",
        text: "Avg View Time",
        style: { width: "110px", minWidth: "110px" },
        formatter: (cell, row) => metric({ ...cell, type: "time" }, row),

        csvFormatter: (cell) => {
          return selectFormat("time", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "mobile",
        text: "Mobile",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "desktop",
        text: "Desktop",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "ctv",
        text: "CTV",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) => {
          return selectFormat("number", cell.value, "0,0");
        },
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "mobile_pct",
        text: "Mobile %",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "desktop_pct",
        text: "Desktop %",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "ctv_pct",
        text: "CTV %",
        style: { width: "110px", minWidth: "110px" },
        formatter: metric,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const trClassFormat = (row) =>
      row.campaign
        ? "content-table-bar-chart__highlight"
        : "content-table-bar-chart__indent";

    const defaultSorted = [];

    const urlParams = new URLSearchParams(this.props.url);

    if (urlParams.has("sortby")) {
      // defines the filter according the URL
      defaultSorted.push({
        dataField: urlParams.get("sortby"),
        order: urlParams.get("order") || "desc",
      });
    } else {
      defaultSorted.push({
        dataField: "min_watched",
        order: "desc",
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";

    const columnsSorted = columns.map((columnName) =>
      table_columns.find((c) => c.dataField === columnName)
    );

    return (
      <>
        {displayTitleWithChart && renderLegendsForTable(labels)}
        <ToolkitProvider
          keyField="id"
          data={data}
          columns={columnsSorted}
          rowClasses={trClassFormat}
          striped={false}
          hover={true}
          bordered={false}
          exportCSV={{
            fileName: filename + ".csv",
            exportAll: false,
            onlyExportFiltered: true,
          }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              defaultSorted={defaultSorted}
              ref={(el) => (this.childRef = el)}
            />
          )}
        </ToolkitProvider>
      </>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const { data, columns } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    let labels = [];

    data.data.forEach((d, i) => {
      labels = labels.concat(
        d.chart
          ?.filter((chart) => !labels.includes(chart.type))
          .map((chart) => chart.type)
      );
      // eslint-disable-next-line no-sequences
      return (d.id = i);
    });

    return this.renderTable(data.data, columns, labels);
  }
}

export default WorldCupPlatformBreakouts;
